
import request from '@api/request'

// 服务总线-列表分类
export const category = params => request.get('/topbus/category', { params })

// 服务总线-获取列表
export const search = params => request.get('/topbus/search', { params })

// 服务总线-详情
export const detail = params => request.get('/topbus/detail', { params })

// 行业数据-获取行业数据列表
export const industryData = params => request.get('/topbus/industryData/list', { params })

// 检索功能
export const searchList = params => request.get('/topbus/search/list', { params })
